import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs';
import { siteSpecificData } from '../../../environments/site-specific-data';
import { IColumnDefinition } from '../../common/models/column-definition';
import { IResizedColumn } from '../../common/models/table';

const API_URL = siteSpecificData.apiUrlBase;

@Injectable()
export class TenancyScheduleTableColumnsHttpService {

  constructor(private http: HttpClient) { }

  getTenancyScheduleTableColumns(widgetInstanceId: number): Observable<IColumnDefinition[]> {
    const url = `${API_URL}tenancyschedule/${widgetInstanceId}/table/availablecolumns`;
    return this.http
      .get<IColumnDefinition[]>(url).pipe(
        map(table => table || undefined)
      );
  }

  getAllTenancyScheduleTableColumns(): Observable<IColumnDefinition[]> {
    const url = `${API_URL}tenancyschedule/table/columns`;
    return this.http
      .get<IColumnDefinition[]>(url).pipe(
        map(table => table || undefined)
      );
  }

  putTenancyScheduleTableColumns(payload: IColumnDefinition[], widgetInstanceId: number): Observable<any> {
    const url = `${API_URL}tenancyschedule/${widgetInstanceId}/table/updatecolumns`;
    return this.http
      .put(url, payload, { responseType: 'text' });
  }

  setTableDefaultColumns(widgetInstanceId: number): Observable<any> {
    const url = `${API_URL}tenancyschedule/${widgetInstanceId}/table/setdefault`;
    return this.http
      .put(url, [], { responseType: 'text' });
  }

  resizeColumns(payload: IResizedColumn, widgetInstanceId: number): Observable<any> {
    const url = `${API_URL}tenancyschedule/${widgetInstanceId}/table/resizecolumns`;
    return this.http
      .put(url, payload, { responseType: 'text' });
  }

  reorderTenancyScheduleTableColumns(payload: string[], widgetInstanceId: number): Observable<any> {
    const url = `${API_URL}tenancyschedule/${widgetInstanceId}/table/reordercolumns`;
    return this.http
      .put(url, payload, { responseType: 'text' });
  }

}
